export const en = {
  adminPanel: 'admin panel',
  source_table: 'source table',
  source_type: 'type',
  source_status: 'status',
  source_version: 'version',
  access_type: 'access type',
  last_checked: 'last checked',
  error_details: 'error details',
  sources_logs: 'sources logs',
  headless_micorservices: 'headless micorservices',
  module: 'module',
  hits_count: 'number of hits',
  request_body: 'request body',
  start_date: 'start date',
  LastAccessDate: 'last access',
  creationDate: 'creation date',
  ElasticsearchIndexes: 'indexes',
  ElasticsearchIndexesLogs: 'indexes logs',
  documents_count: 'docs count',
  documents_count_success: 'successful docs',
  documents_count_failed: 'failed docs',
  storage_size: 'storage size',
  search_by_name: 'search by name',
  admin_logs: 'admin logs',
  index_name: 'index name',
  new_keys: 'new keys',
  missed_keys: 'missed keys',
  item_type: 'item type',
  item_url: 'item url',
  search_by_url: 'search by url',
  search_by_edition_name: 'search by edition name',
};

export const ar = {
  request_body: 'هيئة الطلب',
};
